import { ReactNode } from 'react';

import clsx from 'clsx';

interface CardWrapperProps {
  eventImage: string;
  children: ReactNode;
  className?: string;
}

const CardWrapper = ({ eventImage, children, className }: CardWrapperProps) => (
  <div
    style={{
      backgroundImage: `url(${eventImage})`,
    }}
    className={clsx(
      'relative w-full rounded-b-[32px] bg-cover bg-center bg-no-repeat px-2 pb-2 lg:rounded-[80px] lg:px-16 lg:pb-16',
      className,
    )}
  >
    <span className="absolute inset-0 rounded-b-[32px] backdrop-blur-[10px] lg:rounded-[80px]" />
    {children}
  </div>
);

export default CardWrapper;
